import request from '@/shared/api/request';

export const getStackletCPUData = (
  id: number,
): Promise<{
  statistics: {
    data: { sys: number; timestamp: number; user: number }[];
    name: string;
    unit: string;
  };
}> =>
  request({
    url: `/stacklets/${id}/statistics/cpu/`,
  });
